var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4592 1.84875C35.9942 -0.61625 31.9992 -0.61625 29.5342 1.84875L1.84973 29.5375C-0.615273 32.0025 -0.615273 35.9933 1.84973 38.454L29.5427 66.147C32.0077 68.612 35.9985 68.612 38.4592 66.147L66.1522 38.454C68.6172 35.989 68.6172 31.9982 66.1522 29.5375L38.4592 1.84875ZM33.9967 17C36.2705 17 38.0512 18.9635 37.8217 21.2288L36.3342 36.1335C36.2843 36.719 36.0163 37.2645 35.5835 37.662C35.1506 38.0594 34.5844 38.28 33.9967 38.28C33.4091 38.28 32.8428 38.0594 32.41 37.662C31.9771 37.2645 31.7092 36.719 31.6592 36.1335L30.1717 21.2288C30.1183 20.6942 30.1774 20.1545 30.3453 19.6442C30.5132 19.1339 30.7861 18.6645 31.1464 18.2661C31.5068 17.8677 31.9466 17.5493 32.4375 17.3312C32.9284 17.1131 33.4596 17.0003 33.9967 17ZM34.0052 42.5C35.1324 42.5 36.2134 42.9478 37.0104 43.7448C37.8075 44.5418 38.2552 45.6228 38.2552 46.75C38.2552 47.8772 37.8075 48.9582 37.0104 49.7552C36.2134 50.5522 35.1324 51 34.0052 51C32.8781 51 31.7971 50.5522 31 49.7552C30.203 48.9582 29.7552 47.8772 29.7552 46.75C29.7552 45.6228 30.203 44.5418 31 43.7448C31.7971 42.9478 32.8781 42.5 34.0052 42.5Z",
    fill: "#FA4141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f72e9c73122b8c6b25ef0fb3a405824d.svg";
export { ForwardRef as ReactComponent };